import { FC, useEffect } from 'react';
import styled from '@emotion/styled';
import { useSetAtom } from 'jotai';
import { useTranslation } from 'next-i18next';
import Button from 'src/components/Button';
import ModalLayout, { MobileModalType, ModalContent, ModalFooter as ModalFooterBase, ModalHeader, ModalHeaderTitle } from 'src/components/ModalLayout';
import { closeModalAtom } from 'src/stores/modal/atoms';
import { EVENT_NAME, EVENT_TYPE } from 'src/types/Event';
import { ModalNavButtonType, ModalType } from 'src/types/Modal';
import { pushEvent } from 'src/utils/event-gateway';
const Modal = styled(ModalLayout)`
  max-width: 500px;
`;
const ModalFooter = styled(ModalFooterBase)`
  width: 100%;
`;
const Desc = styled.div`
  padding: 10px 0px;

  color: ${({
  theme
}) => theme.color.content11};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
`;
const ButtonWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
`;
interface Props {
  onCancelDeletionReservation: () => void;
  onCreateNewAccount: () => void;
}
const CancelDeletionReservationModal: FC<Props> = ({
  onCancelDeletionReservation,
  onCreateNewAccount
}) => {
  const {
    t
  } = useTranslation();
  const closeModal = useSetAtom(closeModalAtom);
  const handleCreateNewAccountClick = () => {
    pushEvent({
      eventType: EVENT_TYPE.POPUP,
      eventName: EVENT_NAME.DELETE_ACCOUNT_SCHEDULED_POPUP__CLICK_CREATE_NEW_ACCOUNT_BUTTON,
      eventParams: {
        action_category: 'click',
        tab: 'login',
        page: 'main',
        target: 'create_new_account_button'
      }
    });
    closeModal(ModalType.CANCEL_DELETION_RESERVATION);
    onCreateNewAccount();
  };
  const handleCancelDeletionReservationClick = () => {
    pushEvent({
      eventType: EVENT_TYPE.POPUP,
      eventName: EVENT_NAME.DELETE_ACCOUNT_SCHEDULED_POPUP__CLICK_RESTORE_ACCOUNT_BUTTON,
      eventParams: {
        action_category: 'click',
        tab: 'login',
        page: 'main',
        target: 'restore_account_button'
      }
    });
    closeModal(ModalType.CANCEL_DELETION_RESERVATION);
    onCancelDeletionReservation();
  };
  useEffect(() => {
    pushEvent({
      eventType: EVENT_TYPE.POPUP,
      eventName: EVENT_NAME.LOGIN__IMPRESSION_DELETE_ACCOUNT_SCHEDULED_POPUP,
      eventParams: {
        action_category: 'impression',
        tab: 'login',
        page: 'main',
        target: 'delete_account_scheduled_popup'
      }
    });
  }, []);
  return <Modal isDim mobileType={MobileModalType.BOTTOM_SHEET} navButtonType={ModalNavButtonType.CLOSE} closeWhenClickOutside={false} data-sentry-element="Modal" data-sentry-component="CancelDeletionReservationModal" data-sentry-source-file="index.tsx">
      <ModalHeader data-sentry-element="ModalHeader" data-sentry-source-file="index.tsx">
        <ModalHeaderTitle mobileType={MobileModalType.BOTTOM_SHEET} buttonType={ModalNavButtonType.CLOSE} data-sentry-element="ModalHeaderTitle" data-sentry-source-file="index.tsx">
          {t('login__relogin_confirm_title')}
        </ModalHeaderTitle>
      </ModalHeader>
      <ModalContent data-sentry-element="ModalContent" data-sentry-source-file="index.tsx">
        <Desc data-sentry-element="Desc" data-sentry-source-file="index.tsx">{t('login__relogin_confirm_description')}</Desc>
      </ModalContent>
      <ModalFooter data-sentry-element="ModalFooter" data-sentry-source-file="index.tsx">
        <ButtonWrap data-sentry-element="ButtonWrap" data-sentry-source-file="index.tsx">
          <Button id='CREATE_NEW_ACCOUNT_BUTTON' onClick={handleCreateNewAccountClick} color='secondary' data-sentry-element="Button" data-sentry-source-file="index.tsx">
            {t('login__relogin_create_new_button')}
          </Button>
          <Button id='CANCEL_DELETION_RESERVATION_BUTTON' onClick={handleCancelDeletionReservationClick} color='primary' data-sentry-element="Button" data-sentry-source-file="index.tsx">
            {t('login__relogin_confirm_button')}
          </Button>
        </ButtonWrap>
      </ModalFooter>
    </Modal>;
};
export default CancelDeletionReservationModal;